<template>
  <v-dialog v-model="show" persistent max-width="290">
    <v-card>
      <v-card-title class="headline">{{
        $t('notification.attention')
      }}</v-card-title>
      <v-card-text>
        {{ $t('notification.lateAttention', { count }) }} <br />
        {{ $t('notification.lateAttentionComment') }}
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="green darken-1" text @click="show = false">{{
          $t('common.ok')
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import templateMixin from './templateMixin';

export default {
  mixins: [templateMixin],
  props: {
    count: {
      required: true,
    },
  },
  name: 'LateList',
};
</script>

<style scoped></style>
